function Logo() {
  return (
    <div className="flex text-xl">
      <span className="text-white font-medium">
        <span className="font-bold">Rocket</span> Health
      </span>
    </div>
  );
}

export default Logo;
